import { Lang, locales } from './locales';

const LANG_KEY = 'henry_lang';
type TelegramWindow = {
  Telegram?: {
    WebApp?: {
      initDataUnsafe?: {
        user?: { language_code?: string };
      };
    };
  };
};
type TelegramProxyWindow = {
  TelegramWebviewProxy?: {
    initParams?: { tgWebAppData?: string };
  };
};

function detectTelegramLang(): string | null {
  const fromWindow = (window as TelegramWindow)
    .Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
  if (fromWindow) return fromWindow;

  const fromSdk = (window as TelegramProxyWindow).TelegramWebviewProxy;
  if (!fromSdk?.initParams?.tgWebAppData) return null;

  const parsed = new URLSearchParams(fromSdk.initParams.tgWebAppData);
  const userRaw = parsed.get('user');
  if (!userRaw) return null;
  try {
    const user = JSON.parse(userRaw) as { language_code?: string };
    return user.language_code ?? null;
  } catch (error) {
    console.warn('Failed to parse Telegram user locale from tgWebAppData', error);
    return null;
  }
}

export function getLang(): Lang {
  const saved = localStorage.getItem(LANG_KEY);
  if (saved === 'ru' || saved === 'en') return saved;

  const tgLang = detectTelegramLang();
  if (tgLang?.toLowerCase().startsWith('ru')) return 'ru';

  if (navigator.language.toLowerCase().startsWith('ru')) return 'ru';

  return 'en';
}

export function setLang(lang: Lang): void {
  localStorage.setItem(LANG_KEY, lang);
}

export function toggleLang(): Lang {
  const next: Lang = getLang() === 'en' ? 'ru' : 'en';
  setLang(next);
  return next;
}

export function t(key: string): string {
  return locales[getLang()][key] ?? key;
}

export function tWithFallback(key: string, fallback: string): string {
  const translated = t(key);
  return translated === key ? fallback : translated;
}
